import React from 'react';
import Layout from "../Components/Layout"; // Importeert de Layout component
import '../Styles/global.css'; // Importeert CSS voor styling

const Over = () => {
    return (
        <Layout>
            <div className="over-container">
                <h1>Wie zijn wij?</h1>
                <h2 className="team-desc">
                    <p>Wij van het Gebakken Aardappeltje hebben als doel een sterrenchef-ervaring toegankelijk te maken
                        voor de gewone burger in Nederland.</p>
                    <p>Onze topchefs delen hun geheime recepten, die jij aan de hand van onze instructies thuis kunt
                        bereiden. En dit allemaal met normale ingrediënten die je in de supermarkt kunt vinden. In samenwerking met Albert Heijn,
                        zorgen wij ervoor dat u gemakkelijk deze wereldgerechten kan maken in het comfort van uw eigen huis </p>
                </h2>
            </div>
        </Layout>
    );
};

export default Over;